import { Platform } from 'react-native';

export const isExpectedWebChecklistShareResolveError = (error: unknown): boolean => {
  if (Platform.OS !== 'web' || !error || typeof error !== 'object') {
    return false;
  }

  const { statusCode, shareStatus } = error as { statusCode?: unknown; shareStatus?: unknown };
  // Somente a confirmação HTTP da API torna o encerramento um resultado esperado.
  return statusCode === 410 &&
    (shareStatus === 'completed' || shareStatus === 'expired' || shareStatus === 'revoked');
};
